import { curry } from 'lodash';
import { split, flow, get, map, tap } from 'lodash/fp';
import { find } from 'lodash';

/**
 * @param {HTMLElement} el
 * @returns {DOMRect}
 */
export const getBoudingClientRect = el => el.getBoundingClientRect();

export const findElement = curry((className, elList) =>
    {
        return find(
            elList,
            /**
             * @param {HTMLElement} el
             */
            el => {
                return el.classList.contains(className);
            }
        )
    }
);

export const getComputedStyle = window.getComputedStyle;

// const gridAreaInfoToConfig = arr => ({
//     Row: arr[0],
//     Column: arr[1],
//     Rows: arr[2] - arr[0],
//     Columns: arr[3] - arr[1]
// });

// export const analyzeGridArea = flow([
//     getComputedStyle,
//     get('gridArea'),
//     split('/'),
//     map(parseInt),
//     gridAreaInfoToConfig
// ]);
